import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { PaintBucket, Wrench, ArrowRight, ShieldCheck, Sparkles } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BodyshopSection() {
  const [url, setUrl] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/settings`);
        if (!cancelled) setUrl(data.bodyshop_url || '');
      } catch {}
    })();
    return () => { cancelled = true; };
  }, []);

  const goToBodyshop = () => {
    if (!url) return;
    if (url.startsWith('http://') || url.startsWith('https://')) {
      window.open(url, '_blank', 'noopener');
    } else {
      // Internal path like /bodyshop
      window.location.href = url;
    }
  };

  const disabled = !url;

  return (
    <section id="bodyshop" className="relative py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="rounded-3xl p-[1.5px]" style={{background:'linear-gradient(135deg,#a855f7,#ec4899)'}}>
          <div className="rounded-3xl bg-[#0f0f16] p-6 md:p-10 grid md:grid-cols-[1.4fr_1fr] gap-8 items-center">
            <div>
              <div className="tag-pill mb-4"><PaintBucket className="w-3 h-3" /> BODYSHOP</div>
              <h2 className="text-3xl md:text-5xl font-extrabold">
                <span className="text-white">Denting, Painting & </span><span className="gradient-text">Bodyshop</span>
              </h2>
              <p className="mt-3 text-gray-300 max-w-xl">
                કારના બોડી-વર્ક માટે અલગ સ્પેશિયલાઇઝ્ડ સ્ટુડિયો — ડેન્ટ રિમૂવલ, પેઇન્ટિંગ, એક્સિડન્ટ રિપેર, ડિટેલિંગ ને ઇન્શ્યોરન્સ ક્લેમ સપોર્ટ. પ્રોફેશનલ સ્પ્રે બુથ ને જેન્યુઈન પેઇન્ટ.
              </p>
              <div className="mt-6 grid sm:grid-cols-3 gap-3">
                <div className="flex items-center gap-2 rounded-xl border border-purple-900/60 px-3 py-2 text-sm text-gray-200"><Wrench className="w-4 h-4 text-pink-400" /> ડેન્ટ & પેઇન્ટ</div>
                <div className="flex items-center gap-2 rounded-xl border border-purple-900/60 px-3 py-2 text-sm text-gray-200"><ShieldCheck className="w-4 h-4 text-pink-400" /> ઇન્શ્યોરન્સ ક્લેમ</div>
                <div className="flex items-center gap-2 rounded-xl border border-purple-900/60 px-3 py-2 text-sm text-gray-200"><Sparkles className="w-4 h-4 text-pink-400" /> ડિટેલિંગ</div>
              </div>
              <Button onClick={goToBodyshop} disabled={disabled} className={`rounded-full h-12 px-6 mt-7 font-semibold ${disabled ? 'bg-gray-700 text-gray-400 cursor-not-allowed' : 'gradient-btn'}`}>
                {disabled ? 'Coming Soon' : 'Bodyshop ની મુલાકાત લો'} {!disabled && <ArrowRight className="w-4 h-4 ml-2" />}
              </Button>
            </div>

            <div className="hidden md:block">
              <div className="relative rounded-2xl overflow-hidden border border-purple-900/50 aspect-[4/3]">
                <div className="absolute inset-0" style={{background:'linear-gradient(135deg,rgba(168,85,247,.25),rgba(236,72,153,.25))'}} />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="text-center">
                    <div className="w-20 h-20 mx-auto rounded-full flex items-center justify-center" style={{background:'linear-gradient(135deg,#a855f7,#ec4899)'}}>
                      <PaintBucket className="w-10 h-10 text-white" />
                    </div>
                    <div className="mt-4 gradient-text text-2xl font-extrabold">Onestop Bodyshop</div>
                    <div className="text-xs text-gray-400 mt-1">Vadodara · Professional Studio</div>
                  </div>
                </div>
                <div className="absolute inset-0 grid-bg opacity-40" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
